var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216,28H72A36.04061,36.04061,0,0,0,36,64v72a20.0226,20.0226,0,0,0,20,20h46.77588a3.9991,3.9991,0,0,1,3.95947,4.56641L100.04,207.43457A4.05553,4.05553,0,0,0,100,208a28,28,0,0,0,56,0,4.05553,4.05553,0,0,0-.04-.56543l-6.69531-46.86816A3.99981,3.99981,0,0,1,153.22412,156H200a20.0226,20.0226,0,0,0,20-20V32A4.0002,4.0002,0,0,0,216,28ZM72,36H180V80a4,4,0,0,0,8,0V36h24v72H44V64A28.03146,28.03146,0,0,1,72,36ZM200,148H153.22412a11.999,11.999,0,0,0-11.87939,13.69727l6.65332,46.57421a19.99989,19.99989,0,0,1-39.9961,0l6.65332-46.57324A11.99971,11.99971,0,0,0,102.77588,148H56a12.01343,12.01343,0,0,1-12-12V116H212v20A12.01343,12.01343,0,0,1,200,148Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.ab182832790ddd441f5aa67603b77abc.svg";
export { ForwardRef as ReactComponent };